APP.modal = function (element, options) {
	return true
}
